import { DataProvider } from 'react-admin'
import { BarrierDto } from '../../dto/device/barrier/barrier.dto'

const fakeBarriers: BarrierDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeBarriers, total: fakeBarriers.length }),
} as DataProvider

export default provider
